module.exports = __webpack_public_path__ + "static/media/maxim.a3957e5c.jpeg";